module.exports = __webpack_public_path__ + "img/w17-qr.4f2074ac.jpg";